module.exports = __webpack_public_path__ + "img/bd.c47c342c.jpg";